//@ts-check

export const CLOUDAPP_STAGE_CREATE = 'cloudAppStage-create'
export const CLOUDAPP_STAGE_READ = 'cloudAppStage-read'
export const CLOUDAPP_STAGE_UPDATE = 'cloudAppStage-update'
export const CLOUDAPP_STAGE_DELETE = 'cloudAppStage-delete'

export const CLOUDUSER_READ = 'cloudUser-read'
